import React, { Fragment, useState } from "react";
import { getReportsList } from "./reports.service";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";

const Reports = () => {

    const [globalFilter, setGlobalFilter] = useState("");
    const [reportList, setReportList] = useState([]);

    const handleReportClick = async (type) => {
        const records = await getReportsList(type);
        if (records.length > 0) {
            setReportList(records);
        } else {
            setReportList([]);
        }
    };

    const tableHeader = (
        <div className="table-header">
            All List
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
            </span>
        </div>
    );

    const bodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                <span style={{textTransform:"capitalize"}}>{data[props.field]}</span>
            </>
        );
    };

    return (
        <Fragment>
            <div className="grid mb-4">
                <div className="col-12 lg:col-6 xl:col-4">
                    <div className="card mb-0" onClick={() => handleReportClick("solution")}>
                        <div className="flex justify-content-between mb-3">
                            <div>
                                <span className="block text-500 font-medium mb-3">Solutions Downloaded Report</span>
                            </div>
                            <div className="flex align-items-center justify-content-center bg-orange-100 border-round" style={{ width: "2.5rem", height: "2.5rem" }}>
                                <i className="pi pi-map-marker text-orange-500 text-xl" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 lg:col-6 xl:col-4" onClick={() => handleReportClick("segment")}>
                    <div className="card mb-0">
                        <div className="flex justify-content-between mb-3">
                            <div>
                                <span className="block text-500 font-medium mb-3">Segments Downloaded Report</span>
                            </div>
                            <div className="flex align-items-center justify-content-center bg-cyan-100 border-round" style={{ width: "2.5rem", height: "2.5rem" }}>
                                <i className="pi pi-inbox text-cyan-500 text-xl" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {reportList && reportList.length > 0 && (
                <div className="grid table-demo">
                    <div className="col-12">
                        <div className="card">
                            <DataTable
                                value={reportList}
                                scrollable
                                scrollHeight="600px"
                                className="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-customers"
                                rows={10}
                                dataKey="id"
                                paginator
                                rowHover
                                globalFilter={globalFilter}
                                emptyMessage="No records found."
                                header={tableHeader}
                                scrollDirection="both"
                            >
                                <Column style={{ flexGrow: 1, flexBasis: "200px" }} field="userInfo.name" header="Name" sortable></Column>
                                <Column style={{ flexGrow: 1, flexBasis: "200px" }} field="userInfo.company_name" header="Company Name" sortable></Column>
                                <Column style={{ flexGrow: 1, flexBasis: "200px" }} field="userInfo.email" header="Email" sortable></Column>
                                <Column style={{ flexGrow: 1, flexBasis: "200px" }} field="userInfo.mobile_number" header="Mobile" sortable></Column>
                                <Column style={{ flexGrow: 1, flexBasis: "200px" }} field="type" header="Type" sortable body={bodyTemplate}></Column>
                                <Column style={{ flexGrow: 1, flexBasis: "200px" }} field="type_name" header="Type Name" sortable body={bodyTemplate}></Column>
                            </DataTable>
                        </div>
                    </div>

                </div>
            )}
        </Fragment>
    );
};

export default Reports;
